import { 
  OFFICE_STATS_YEAR, OFFICE_STATS_MONTH, OFFICE_STATS_SWITCH, OFFICE_STATS_RESET, OFFICE_STATS_SELECT_DAY, OFFICE_STATS_CHANGE_DATE,
  PENDING, FULFILLED, REJECTED,
} from '../globals';

import {
  STATS_DEFAULT_SETTING,
} from '../config';

export const initialState = {
  statsChecked: 'waitingTime',
  dateChecked: STATS_DEFAULT_SETTING,
  year: -1,
  month: -1,
  selected: {
    day: -1,
    month: -1,
    year: -1,
  },
  statsYear: {
    isLoading: false,
    catchedData: false,
    status: false,
    error: false,
    data: {
      stats: [],
      maxValue: [],
    },
    errorMessage: [],
  },
  statsMonth: {
    isLoading: false,
    catchedData: false,
    status: false,
    error: false,
    data: {
      stats: [],
      maxValue: [],
    },
    errorMessage: [],
  },
};


const parseGraphData = (inData) => {
  let newData = [];
  let newChartData;
  let dayIndex;
  let tmpCliSum;
  let tmpAvgTime;
  let maxCliSum = 0;
  let maxAvgTime = 0;

  for (let i = 0; i < inData.length; i++) {
    dayIndex = i === 0 ? 6 : i - 1;
    newChartData = {
      clients_sum: [],
      avg_time: [],
      labels: [],
    }

    // if data are empty
    if (inData[i].data === null) {
      newChartData = null;
    }
    else {
      const objKeys = Object.keys(inData[i].data);
      for (let j = 0; j < objKeys.length; j++) {
        tmpCliSum = inData[i].data[objKeys[j]].clients_sum;
        tmpAvgTime = inData[i].data[objKeys[j]].avg_time / 60;
        
        // get max values
        if (tmpCliSum > maxCliSum)
          maxCliSum = tmpCliSum;
        if (tmpAvgTime > maxAvgTime)
          maxAvgTime = tmpAvgTime;

        // fill data for one chart
        newChartData.clients_sum.push(tmpCliSum);
        newChartData.avg_time.push(tmpAvgTime);
        newChartData.labels.push(inData[i].data[objKeys[j]].hour + ':00');
      }
    }
    newData[dayIndex] = newChartData;
  }

  return {
    maxCliSum: maxCliSum + maxCliSum * 0.1,
    maxAvgTime: maxAvgTime + maxAvgTime * 0.1,
    stats: newData,
  };
}


const reducer = (state = initialState, action) => {
  switch (action.type) {
   
    case `${OFFICE_STATS_YEAR}_${PENDING}`:
      return {
        ...state,
        statsYear: {
          ...state.statsYear,
          isLoading: true,
          catchedData: true,
        },
      };

    case `${OFFICE_STATS_YEAR}_${FULFILLED}`:
      return {
        ...state,
        year: action.payload.year,
        month: action.payload.month,
        statsYear: {
          ...state.statsYear,
          isLoading: false,
          status: action.payload.status,
          data: parseGraphData(action.payload.data),
          catchedData: true,
        },
        statsMonth: {
          ...state.statsMonth,
          catchedData: action.payload.year === state.year && action.payload.month === state.month ? state.statsMonth.catchedData : false,
        },
      }

    case `${OFFICE_STATS_YEAR}_${REJECTED}`: 
      return {
        ...state,
        statsYear: {
          ...state.statsYear,
          isLoading: false,
          status: false,
          error: true,
          errorMessage: action.payload.error,
        },
      };


    case `${OFFICE_STATS_MONTH}_${PENDING}`:
      return {
        ...state,
        statsMonth: {
          ...state.statsMonth,
          isLoading: true,
          catchedData: true,
        },
      };

    case `${OFFICE_STATS_MONTH}_${FULFILLED}`:
      return {
        ...state,
        year: action.payload.year,
        month: action.payload.month,
        statsMonth: {
          ...state.statsMonth,
          isLoading: false,
          status: action.payload.status,
          data: parseGraphData(action.payload.data),
          catchedData: true,
        },
        statsYear: {
          ...state.statsYear,
          catchedData: action.payload.year === state.year ? state.statsYear.catchedData : false,
        },
      }

    case `${OFFICE_STATS_MONTH}_${REJECTED}`: 
      return {
        ...state,
        statsMonth: {
          ...state.statsMonth,
          isLoading: false,
          status: false,
          error: true,
          errorMessage: action.payload.error,
        },
      };


    case `${OFFICE_STATS_SWITCH}`:
      return {
        ...state,
        statsChecked: action.payload.statsChecked,
        dateChecked: action.payload.dateChecked,
      };

    case `${OFFICE_STATS_RESET}`:
      return {
        ...initialState,
      }

    case `${OFFICE_STATS_SELECT_DAY}`:
      return {
        ...state,
        selected: {
          day: action.payload.day,
          month: action.payload.month,
          year: action.payload.year,
        }
      }

    case `${OFFICE_STATS_CHANGE_DATE}`:
      return {
        ...state,
        month: action.payload.month,
        year: action.payload.year,
        statsYear: {
          ...state.statsYear,
          catchedData: action.payload.year === state.year ? state.statsYear.catchedData : false,
        },
        statsMonth: {
          ...state.statsMonth,
          catchedData: action.payload.year === state.year && action.payload.month === state.month ? state.statsMonth.catchedData : false,
        },
      }
    
    default:
      return state;
  }
};

export default reducer;
